import axios from "axios";
import router from "../../router";

axios.defaults.timeout = 2000; // 2 sec

const searchList = [
	"https://rdap.apnic.net",
	"https://rdap.db.ripe.net",
	"https://rdap.afrinic.net/rdap",
	"https://rdap.arin.net/registry",
	"https://rdap.lacnic.net/rdap"
];

const state = {
	data: null,
	error: null,
	isSearching: false,
	searchingProgress: 0
};

const getters = {
	data: state => {
		return state.data;
	},
	error: state => {
		return state.error;
	},
	dataIsReady: state => {
		return !!state.data && !state.error;
	},
	isSearching: state => {
		return state.isSearching;
	},
	searchingProgress: state => {
		return state.searchingProgress;
	}
};

const mutations = {
	setData(state, data) {
		state.data = data;
	},
	setError(state, errorCode) {
		state.error = errorCode;
	},
	setSearchingState(state, isSearching) {
		state.isSearching = isSearching;
		if (isSearching) {
			state.searchingProgress = 0;
		}
	},
	setSearchingProgress(state, progress) {
		state.searchingProgress = progress;
		if (progress === 100) {
			// solve progress bar disappear before reaching 100%;
			setTimeout(() => {
				state.isSearching = false;
			});
		}
	}
};

const actions = {
	search: ({ commit, dispatch }, payload) => {
		const { type } = payload;
		let { address, bits } = payload;
		dispatch("clearSearchResult");

		address = address.replace(/%2[f|F]/g, "/");
		if (address.split("/").length > 2) {
			return dispatch("handleInvalidSearch");
		}
		// handle invalid search case
		if (address.includes("script")) {
			return dispatch("handleInvalidSearch");
		}
		if (bits) {
			if (address.includes("/")) {
				return dispatch("handleInvalidSearch");
			}
			if (type === "autnum" || type === "entity") {
				return dispatch("handleInvalidSearch");
			}
			if (type === "ip") {
				if (!Number.isInteger(Number(bits))) {
					return dispatch("handleInvalidSearch");
				}
			}
		}

		if (type === "ip") {
			if (bits) {
				address = `${address}/${bits}`;
			}
		} else if (type === "autnum") {
			if (Number(address) > 0) {
				address = "AS" + address;
			} else {
				address = address.slice(2);
				address = "AS" + address;
			}
		} else {
			address = address.toUpperCase();
		}
		router.push(`/${type}/${address}`);
		commit("setSearchingState", true);
		address = type === "autnum" ? address.slice(2) : address;
		dispatch("searchLoop", { type, address });
	},
	searchLoop: ({ commit }, payload) => {
		const { type, address } = payload;
		let errorCount = 0;
		let resFound = false;
		searchList.forEach(region => {
			axios
				.get(`${region}/${type}/${encodeURI(address)}`)
				.then(res => {
					if (resFound) {
						return;
					}
					resFound = true;
					commit("setSearchingProgress", 100);
					commit("setData", res.data);
				})
				.catch(err => {
					if (resFound) {
						return;
					}
					const percent = (++errorCount / searchList.length) * 100;
					commit("setSearchingProgress", percent);
					// last rb reached
					if (errorCount === searchList.length) {
						commit(
							"setError",
							err.response && err.response.status ? err.response.status : 400
						);
					}
				});
		});
	},
	handleInvalidSearch({ commit }) {
		commit("setError", 808);
	},
	clearSearchError({ commit }) {
		commit("setError", null);
	},
	clearSearchResult({ commit }) {
		commit("setData", null);
		commit("setError", null);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
